// extracted by mini-css-extract-plugin
export default {"welcome":"Header_welcome__R657C","sdkContainer":"Header_sdkContainer__oRW-w"};